import { Channel, RTC, s, Shape } from "@kosmod/pancake";
import { Player, PlayerID } from "@kosmod/sesame";
import { RoomSessionChannel } from "./session";
import { Logger } from "@kosmod/kit";
import { filter, Observable } from "rxjs";

export const VoiceSessionAction = s.o({
  destination: PlayerID,
  message: RTC.SignalMessage,
});
export type VoiceSessionAction = Shape.Type.Of<typeof VoiceSessionAction>

export const VoiceSessionEvent = s.o({
  source: PlayerID,
  message: RTC.SignalMessage,
});
export type VoiceSessionEvent = Shape.Type.Of<typeof VoiceSessionEvent>

export type VoiceSessionChannel = Channel.Type<VoiceSessionAction, VoiceSessionEvent>;

export const createVoiceSessionHost = (logger: Logger) => {
  const players = new Map<PlayerID, Channel.Port.Server<VoiceSessionChannel>>();

  return {
    connect(player: Player, port: Channel.Port.Server<VoiceSessionChannel>) {
      players.set(player.id, port);
      const sub = port.receive.subscribe((action) => {
        const destinationPlayer = players.get(action.destination);
        if (!destinationPlayer)
          return logger.log(`Failed to send VoiceSessionMessage to "${action.destination}": Player Unknown`);

        logger.log(`Sending ${action.message.type} to "${action.destination}"`);
        destinationPlayer.send({
          source: player.id,
          message: action.message,
        });
      })

      return {
        disconnect() {
          sub.unsubscribe();
          players.delete(player.id);
        }
      }
    }
  }
};


export const createVoiceSessionClient = (
  self: Player,
  port: Channel.Port.Client<VoiceSessionChannel>
) => {
  const offers = port.receive.pipe(filter(m => m.message.type === 'offer'))
  
  return {
    subjects: {
      offers
    },
    createSignalingChannel(destination: PlayerID) {
      return Channel.map(port)<RTC.SignalMessage, RTC.SignalMessage>({
        send(message) {
          return { destination, message }
        },
        receive(receive) {
          if (receive.source === destination) {
            return receive.message;
          }
          return null;
        },
      })
    }
  }
}